import { useCallback } from "react";

import { ADMINCENTER_ITEM_UPDATED_EVENT_NAME } from "../../constants/constants";
import { ChangeEventData } from "../../lib/sync-updaters";

export const useUpdateSync = () => {
    // Memoized with no dependencies: the body closes over nothing but `window` and a module
    // constant, so a stable identity is safe. Callers put `fireChangeEvent` in their own
    // `useCallback`/`useEffect` dep arrays, and an unstable reference here would silently defeat
    // that memoization on every render.
    const fireChangeEvent = useCallback(
        ({ isPartial, type, data }: { isPartial?: boolean; type: string; data: ChangeEventData }) => {
            window.dispatchEvent(
                new CustomEvent(ADMINCENTER_ITEM_UPDATED_EVENT_NAME, {
                    detail: {
                        isPartial: Boolean(isPartial),
                        type,
                        data
                    }
                })
            );
        },
        []
    );

    return {
        fireChangeEvent
    };
};
